import { ReactNode } from 'react';
import { Globe } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';

import { cn } from '@components/primitives';

import { useFavicon } from './utilities';

import css from './styles.module.css';

type DomainIconProps = {
  size?: number | `${number}%` | 'auto';
  className?: string;
  domain: string;
  fallback?: ReactNode;
};

// Takes a given url and returns the favicon for it
export function DomainIcon({
  domain,
  size,
  className,
  fallback,
}: DomainIconProps) {
  const { data, isInitialLoading } = useFavicon(domain);

  const sizeValue = typeof size === 'number' ? `${size}px` : size;

  return (
    <div
      className={cn(css.icon, className)}
      style={{ '--size': sizeValue ?? '40px' }}
    >
      <AnimatePresence initial={false}>
        {!isInitialLoading && data && (
          <motion.img
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
            src={data}
            alt={domain}
          />
        )}
      </AnimatePresence>

      <AnimatePresence initial={false}>
        {!isInitialLoading && !data && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
            className={css.fallback}
          >
            {typeof fallback !== 'undefined' ? fallback : <Globe aria-hidden />}
          </motion.div>
        )}
      </AnimatePresence>

      <div className={css.loading} data-loading={isInitialLoading} />
    </div>
  );
}
